'use client'
// =============================================================================
// SessionWatcher — force une déconnexion PROPRE dès que le refresh du token
// OIDC échoue (session.error === 'RefreshAccessTokenError', voir auth.ts::jwt
// callback), au lieu de laisser l'usager "avoir l'air connecté" (cookie
// session NextAuth valide 30j) pendant que le token porteur réel est mort
// depuis longtemps (OIDC ~1h, rafraîchi seulement à l'usage).
//
// Le même check existe déjà dans auth.config.ts::authorized() (middleware) —
// mais le middleware ne s'exécute QU'À LA NAVIGATION complète, jamais pendant
// qu'on reste sur la même page à faire des fetch en place. useSession() se
// re-synchronise au retour de focus de l'onglet (refetchOnWindowFocus,
// SessionProvider ci-dessous) — exactement le scénario rapporté : revenir
// sur un onglet laissé ouvert un moment, où l'API échoue silencieusement
// (401 avalés un par un par chaque appel) sans jamais déconnecter proprement.
//
// Rendu : rien — composant purement observateur, monté une fois sous
// <SessionProvider> dans layout.tsx.
// =============================================================================
import { useEffect } from 'react'
import { useSession } from 'next-auth/react'

export function SessionWatcher() {
  const { data: session } = useSession()

  useEffect(() => {
    if (session?.error === 'RefreshAccessTokenError') {
      // Déconnexion FÉDÉRÉE : si le refresh token est mort, la session SSO
      // d'Authentik peut, elle, être encore ouverte — un signOut local
      // renverrait l'usager sur un login qui le reconnecte aussitôt, sans
      // jamais lui dire pourquoi il a été déconnecté.
      window.location.href = '/api/auth/federated-logout?reason=expired'
    }
  }, [session?.error])

  return null
}
